/**
 * Rendered when a vanity subdomain doesn't match any org (TRA-829).
 * Shown pre-auth, so no app chrome and no data — a real 404, not a
 * broken shell.
 */
export default function OrgNotFoundPage({ slug }: { slug: string }): React.JSX.Element {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-serif font-semibold mb-4">404</h1>
        <p className="text-muted-foreground mb-6">
          No organization named &ldquo;{slug}&rdquo; exists.
        </p>
        <a
          href="https://platform.trainloop.ai"
          className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90"
        >
          Go to TrainLoop
        </a>
      </div>
    </div>
  )
}
